import"react/jsx-runtime";import{VersionVariants as r}from"@jobseeker/lotus/lib/enums";import m from"./V1/index.js";import o from"./V2/index.js";var e={};e[r.VERSION_ONE]=m,e[r.VERSION_TWO]=o;
//# sourceMappingURL=index.js.map
